module.exports = __webpack_public_path__ + "img/page12.8ed09fc2.png";